import React from 'react'
import SummaryOrder from './SummaryOrder'
import OrderTable from './OrderTable'
import { useIntl } from 'react-intl'
import messages from '../../../messages'
import ErrorAlert from '@src/routes/Configurators/components/ErrorAlert'
import { TubeProperties } from '../enum'
import ValidationWarnings from '../../../validations/ValidationWarnings'
import { configContext } from '../../../utils/StandardReducer'
import {
  ConfiguratorProductDetails,
  StandardConfiguratorAddToMiniCart,
} from '../../ConfiguratorSharedTypes'

interface ConfirmOrderProps {
  productDetails: ConfiguratorProductDetails
  configuratorAddToMiniCart: StandardConfiguratorAddToMiniCart
  itemDetails: any
  specificationsData: any
}

const ConfirmOrder: React.FC<ConfirmOrderProps> = (props) => {
  const intl = useIntl()
  const [message, setMessage] = React.useState<string>('')
  const warningMsg: string[] = []
  const [open, setOpen] = React.useState(false)
  const { state } = React.useContext(configContext)
  const [isDisplayWarning, setIsDisplayWarning] = React.useState(false)
  const updateError = (value) => {
    if (value === TubeProperties.PriceHeaderError) {
      warningMsg.length = 0
      warningMsg.push(intl.formatMessage(messages.PC_PRICE_ERROR_EMPTY_PRICE))
      setIsDisplayWarning(true)
    } else if (value === true || value === false) {
      if (value) {
        setMessage(intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2))
      } else {
        setMessage('')
        setOpen(value)
      }
    } else {
      setMessage(value)
      setOpen(true)
    }
  }

  React.useEffect(() => {
    if (state.pageError.length) {
      setOpen(true)
    } else {
      setOpen(false)
    }
  }, [state.pageError])

  return (
    <>
      <div>
        <ErrorAlert open={open} setOpen={setOpen} message={message} />
      </div>
      <div>
        <OrderTable
          productDetails={props.productDetails}
          updateError={updateError}
          specificationsData={props.specificationsData}
          errorMessage={message}
        />
        {isDisplayWarning ? (
          <div>
            <ValidationWarnings warnings={warningMsg} />
          </div>
        ) : (
          ''
        )}

        <SummaryOrder
          productDetails={props.productDetails}
          configuratorAddToMiniCart={props.configuratorAddToMiniCart}
          updateError={updateError}
          itemDetails={props.itemDetails}
        />
      </div>
    </>
  )
}

export default ConfirmOrder
